import React from "react";
import Blurb from "Signups/SharedComponents/MarketingBlurb";

export default function FNPMarketingBlurb() {
  return (
    <Blurb.Container>
      <Blurb.Title>
        <Blurb.Icon className="fas fa-users" />
        <h2>Get Flocknote People</h2>
      </Blurb.Title>

      <p>
        With Flocknote People you can collect and track more, better, and
        brighter information.
      </p>
      <p>
        Sign up today and get all the great things Flocknote People gives you.
      </p>
      <ul>
        <li>The full Family Registration experience</li>
        <li>Custom profile fields</li>
        <li>Household groupings</li>
        <li>Giving Tracking</li>
        <li>Parental Contacts</li>
        <li>And more!!!</li>
      </ul>
    </Blurb.Container>
  );
}
